import Vue from 'vue';
import 'vuetify/dist/vuetify.min.css';
import debounce from 'debounce';

Vue.prototype.$debounce = debounce(function(this: any, methodName: string, ...parameters: any[]) {
  (this as any)[methodName].call(this as any, ...parameters);
}, 300);
